import { Component } from '@angular/core';

import { ICellRendererParams, IRowNode } from 'ag-grid-community';

import { AbstractCellComponent } from '../../abstract';

interface TreeLine {
  last: boolean;
  level: number;
}

@Component({
  host: { 'data-cid': 'grid-tree-gutter-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  styleUrl: './tree-gutter.component.scss',
  template: `
    <div class="tree-gutter" [style.width.px]="this.gutterWidth">
      @for (line of this.treeLines; track line.level) {
        <div class="tree-line" [class.tree-line-last]="line.last" [style.left.px]="line.level * 20 + 7">
          @if (line.level < this.depth - 1) {
            <div class="tree-line-vertical" style="height: 100%"></div>
          } @else {
            <div class="tree-line-branch" [style.width.px]="8"></div>
          }
        </div>
      }
    </div>
    <span class="tree-value" [style.margin-left.px]="this.gutterWidth">{{ this.displayValue }}</span>
  `,
})
export class GridTreeGutterCellComponent extends AbstractCellComponent<unknown, string> {
  depth = 0;
  displayValue = '';
  treeLines: TreeLine[] = [];
  gutterWidth = 0;

  override agInit(params: ICellRendererParams) {
    super.agInit(params);
    this._compute(params);
  }

  override refresh(params: ICellRendererParams) {
    super.agInit(params);
    this._compute(params);
    return true;
  }

  private _compute(params: ICellRendererParams) {
    const data = params.data;
    const node = params.node;

    const compositionPath: string[] = data?.compositionPath ?? [];
    this.depth = compositionPath.length + 1;

    this.gutterWidth = Math.max((this.depth - 1) * 20, 0);
    this.displayValue = data?.order ?? '';

    this.treeLines = [];
    if (this.depth > 1) {
      let current: IRowNode | null = node.parent;
      for (let level = this.depth - 2; level >= 0; level--) {
        const isLast = this._isLastInGroup(current, node, level === this.depth - 2);
        this.treeLines.push({ last: isLast, level });
        current = current?.parent ?? null;
      }
      this.treeLines.sort((a, b) => a.level - b.level);
    }
  }

  private _isLastInGroup(parent: IRowNode | null, child: IRowNode, isDirect: boolean): boolean {
    if (!parent) {
      return true;
    }
    if (isDirect) {
      const siblings = parent.childrenAfterSort ?? parent.childrenAfterGroup ?? [];
      return siblings.length > 0 && siblings[siblings.length - 1]?.id === child.id;
    }
    const siblings = parent.parent?.childrenAfterSort ?? parent.parent?.childrenAfterGroup ?? [];
    return siblings.length > 0 && siblings[siblings.length - 1]?.id === parent.id;
  }
}
